export default __webpack_public_path__ + "static/media/lottery-bg.200deab5.png";